// eslint-disable-next-line import/no-cycle
import http from '@/tools/http';

export default {
  getAll(orgUUID, pagination) {
    return http.get(`/organizations/${orgUUID}/surveys`, { params: pagination });
  },
  getAllInfo(orgUUID, pagination) {
    return http.get(`/organizations/${orgUUID}/surveys/info`, { params: pagination });
  },
  getSurveySegment(orgUUID, surveyUUID) {
    return http.get(`/organizations/${orgUUID}/surveys/${surveyUUID}/segment`);
  },
  delete(orgUUID, surveyUUID) {
    return http.delete(`/organizations/${orgUUID}/surveys/${surveyUUID}`);
  },
  updateArchive(orgUUID, surveyUUID, statusID) {
    return http.patch(`/organizations/${orgUUID}/surveys/${surveyUUID}/status/${statusID}`);
  },
  getOne(orgUUID, uuid) {
    return http.get(`/organizations/${orgUUID}/surveys/${uuid}`);
  },
  create(orgUUID, data) {
    return http.post(`/organizations/${orgUUID}/surveys`, data);
  },
  update(orgUUID, surveyUUID, data) {
    return http.patch(`/organizations/${orgUUID}/surveys/${surveyUUID}`, data);
  },
  removeSurveyItem(organizationUUID, surveyUUID, itemUUID) {
    return http.delete(`/organizations/${organizationUUID}/surveys/${surveyUUID}/item/${itemUUID}`);
  },
  getReport(orgUUID, uuid) {
    return http.get(`/organizations/${orgUUID}/reports/survey/${uuid}`);
  },
  updateCustomerData(token, data) {
    return http.post(`/survey/dataBoster/${token}`, data, {
      headers: {
        Authorization: '',
      },
    });
  },
  getSurveyWeb(token, interactionUUID) {
    if (interactionUUID) {
      return http.get(`/survey/${token}?interaction_uuid=${interactionUUID}`, {
        headers: {
          Authorization: '',
        },
      });
    }
    return http.get(`/survey/${token}`, {
      headers: {
        Authorization: '',
      },
    });
  },
  savePartialResponses(token, survey) {
    return http.post(`/survey/partial/${token}`, survey, {
      headers: {
        Authorization: '',
      },
    });
  },
  saveCompleteResponses(token, survey) {
    return http.post(`/survey/${token}`, survey, {
      headers: {
        Authorization: '',
      },
    });
  },
};
